module.exports = __webpack_public_path__ + "fonts/Golos-Text_Regular.53bf8e5.ttf";